var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3743_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.97 10C23.41 10 10 23.44 10 40C10 56.56 23.41 70 39.97 70C56.56 70 70 56.56 70 40C70 23.44 56.56 10 39.97 10ZM60.76 28H51.91C50.95 24.25 49.57 20.65 47.77 17.32C53.29 19.21 57.88 23.05 60.76 28ZM40 16.12C42.49 19.72 44.44 23.71 45.73 28H34.27C35.56 23.71 37.51 19.72 40 16.12ZM16.78 46C16.3 44.08 16 42.07 16 40C16 37.93 16.3 35.92 16.78 34H26.92C26.68 35.98 26.5 37.96 26.5 40C26.5 42.04 26.68 44.02 26.92 46H16.78ZM19.24 52H28.09C29.05 55.75 30.43 59.35 32.23 62.68C26.71 60.79 22.12 56.98 19.24 52V52ZM28.09 28H19.24C22.12 23.02 26.71 19.21 32.23 17.32C30.43 20.65 29.05 24.25 28.09 28V28ZM40 63.88C37.51 60.28 35.56 56.29 34.27 52H45.73C44.44 56.29 42.49 60.28 40 63.88ZM47.02 46H32.98C32.71 44.02 32.5 42.04 32.5 40C32.5 37.96 32.71 35.95 32.98 34H47.02C47.29 35.95 47.5 37.96 47.5 40C47.5 42.04 47.29 44.02 47.02 46ZM47.77 62.68C49.57 59.35 50.95 55.75 51.91 52H60.76C57.88 56.95 53.29 60.79 47.77 62.68V62.68ZM53.08 46C53.32 44.02 53.5 42.04 53.5 40C53.5 37.96 53.32 35.98 53.08 34H63.22C63.7 35.92 64 37.93 64 40C64 42.07 63.7 44.08 63.22 46H53.08Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3743_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a76f7c32f9cb70d86ef1ed23f9698094.svg";
export { ForwardRef as ReactComponent };